import React from "react";
import { Link, useLocation,useNavigate } from "react-router-dom";
import { useQuery } from "convex/react";
import { api } from "./convex/_generated/api";
import "./Suggestions.css";


export default function Suggestions() {
  const location = useLocation();
  const navigate= useNavigate();

  console.log("location.state:", location.state);

   
  const sessionId = location.state?.sessionId;

  const user = useQuery(
    api.users.getUserBySession,
    sessionId
      ? { sessionId }
      : "skip"
  );

  const userId =
    location.state?.userId || user?._id;

  const premiumUser = useQuery(
    api.users.getPremiumUserById,
    userId
      ? { userId }
      : "skip"
  );

  
  const progress = useQuery(
    api.progress.getByUserId,
    userId
      ? {
          userId,
        }
      : "skip"
  );

  
  // Get ALL progress records for this user

  
  if (premiumUser === null) {
    navigate("/auth");
    return null;
  }




  console.log("User:", userId);
  console.log("Progress:", progress);

  return (
    <div className="suggestions-page">
      <div className="suggestions-container">

        {/* Header */}
        <div className="suggestions-header">
          <div className="suggestions-badge">
            YOUR WELLNESS JOURNEY
          </div>

          <h1>Your Progress</h1>

          <p>
            Review your progress and explore your personalized suggestions.
          </p>
        </div>

        {/* Navigation Buttons */}
        <div className="suggestions-navigation">

          <Link
            to={`/leaderboard/${userId}`}
            className="navigation-button leaderboard-button"
          >
            Leaderboard
          </Link>

          <Link
            to={`/weeklychallenge/${userId}`}
            className="navigation-button challenge-button"
          >
            Weekly Challenges
          </Link>

          <Link
            to={`/badges/${userId}`}
            className="navigation-button badges-button"
          >
            View Badges & Milestones
          </Link>

        </div>

        {/* Progress */}
        {progress?.length === 0 ? (
          <div className="empty-progress">
            <h2>No Progress Yet</h2>
            <p>No progress records found.</p>
          </div>
        ) : (
          progress?.map((progressItem) => (
            <ProgressWithSuggestions
              key={progressItem._id}
              progress={progressItem}
              userId={userId}
            />
          ))
        )}

      </div>
    </div>
  );
}


function ProgressWithSuggestions({
  progress,
  userId,
}) {
  // Get suggestions for THIS progress record
  // using BOTH progressId and userId
  const suggestions = useQuery(
    api.progress.getByProgressId,
    progress?._id && userId
      ? {
          progressId: progress._id,
          userId: userId,
        }
      : "skip"
  );

  console.log(
    "Suggestions for progress:",
    progress._id,
    suggestions
  );

  return (
    <div className="progress-card">

      {/* Progress Header */}
      <div className="progress-card-header">
        <div>
          <span className="section-label">
            CHECK-IN
          </span>

          <h2>Progress</h2>

          <p>
            User ID: {userId}
          </p>
        </div>
      </div>


      {/* ========================= */}
      {/* PROGRESS CATEGORIES */}
      {/* ========================= */}

      <div className="progress-categories">

        <Link
          className="progress-category"
          to={`/physical-health/${progress._id}/${userId}`}
        >
          <span>Physical Health</span>
          <strong>
            {progress.physicalHealth ?? 0}
          </strong>
          <span className="category-arrow">→</span>
        </Link>

        <Link
          className="progress-category"
          to={`/mental-emotional/${progress._id}/${userId}`}
        >
          <span>Mental & Emotional</span>
          <strong>
            {progress.mentalEmotionalHabit ?? 0}
          </strong>
          <span className="category-arrow">→</span>
        </Link>

        <Link
          className="progress-category"
          to={`/learning-growth/${progress._id}/${userId}`}
        >
          <span>Learning & Growth</span>
          <strong>
            {progress.learningGrowth ?? 0}
          </strong>
          <span className="category-arrow">→</span>
        </Link>

        <Link
          className="progress-category"
          to={`/productivity-career/${progress._id}/${userId}`}
        >
          <span>Productivity & Career</span>
          <strong>
            {progress.productivityCareer ?? 0}
          </strong>
          <span className="category-arrow">→</span>
        </Link>

        <Link
          className="progress-category"
          to={`/financial/${progress._id}/${userId}`}
        >
          <span>Financial</span>
          <strong>
            {progress.financial ?? 0}
          </strong>
          <span className="category-arrow">→</span>
        </Link>

        <Link
          className="progress-category"
          to={`/personal-lifestyle/${progress._id}/${userId}`}
        >
          <span>Personal & Lifestyle</span>
          <strong>
            {progress.personalLifestyle ?? 0}
          </strong>
          <span className="category-arrow">→</span>
        </Link>

        <Link
          className="progress-category"
          to={`/social-relationships/${progress._id}/${userId}`}
        >
          <span>Social & Relationships</span>
          <strong>
            {progress.socialRelationships ?? 0}
          </strong>
          <span className="category-arrow">→</span>
        </Link>

      </div>


      {/* ========================= */}
      {/* SUGGESTIONS */}
      {/* ========================= */}

      <div className="suggestions-section">

        <div className="suggestions-title">
          <span className="section-label">
            PERSONALIZED
          </span>

          <h3>Suggestions</h3>
        </div>

        {suggestions === undefined && (
          <div className="loading-message">
            Loading suggestions...
          </div>
        )}

        {suggestions?.length === 0 && (
          <div className="no-suggestions">
            No suggestions available yet.
          </div>
        )}

        <div className="suggestions-list">

          {suggestions?.map((suggestion) => (
            <div
              key={suggestion._id}
              className="suggestion-card"
            >

              <div className="suggestion-top">
                <div>
                  <h4>
                    {suggestion.suggestionType}
                  </h4>

                  <p className="suggestion-category">
                    Category: {suggestion.category}
                  </p>
                </div>

                <div className="score-badge">
                  {suggestion.score}
                </div>
              </div>

              <div className="suggestion-details">

                <div className="suggestion-detail">
                  <span>Activity</span>
                  <strong>
                    {suggestion.activity}
                  </strong>
                </div>

                <div className="suggestion-detail">
                  <span>Scheduled Time</span>
                  <strong>
                    {suggestion.scheduledTime}
                  </strong>
                </div>

                <div className="suggestion-detail">
                  <span>Allocated Time</span>
                  <strong>
                    {suggestion.allocatedMinutes} minutes
                  </strong>
                </div>

              </div>

              <div className="suggestion-reason">
                <span>Reason</span>
                <p>
                  {suggestion.reason}
                </p>
              </div>

              <Link
                to={`/activity/${suggestion._id}/${userId}`}
                className="start-activity-button"
              >
                Start Activity
                <span>→</span>
              </Link>

            </div>
          ))}

        </div>
      </div>

    </div>
  );
}